import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {ScreenSizeService} from "../services/screen-size.service";
import {RouteTitleService} from "../services/route-title.service";
import {FilterDataService} from "../services/filter-data.service";

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent implements OnInit {

  @Input() isMobileMenuClosed!: boolean;
  @Input() isMobile!: boolean;

  isSidebarMenuToggled: boolean = false;
  currentTitle: string = '';
  filterData!: boolean;

  @Output() toggleSidebarEvent = new EventEmitter<boolean>();
  @Output() mobileMenuCloseEvent = new EventEmitter<boolean>();

  constructor(
    private readonly screenSizeService: ScreenSizeService,
    private readonly routeTitleService: RouteTitleService,
    private readonly filterDataService: FilterDataService,
  ) {
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.initIsMobile();
  }

  ngOnInit(): void {
    this.isMobileMenuClosed = true;
    this.initIsMobile();
    this.initCurrentTitle();
    this.initFilterData();
  }

  get isMobileAndMenuOpen(): boolean {
    return !this.isMobileMenuClosed && this.isMobile;
  }

  get isMobileAndMenuClosed(): boolean {
    return this.isMobileMenuClosed && this.isMobile;
  }

  setSidebarMobileMenuToggled() {
    this.isMobileMenuClosed = !this.isMobileMenuClosed;
  }

  setSidebarMenuToggled(toggled: boolean): void {
    this.isSidebarMenuToggled = toggled;
  }

  handleFilterData(filterData: boolean): void {
    this.filterData = filterData;
  }

  private initFilterData(): void {
    this.filterDataService.filterData$.subscribe({
      next: (filterData: boolean) => {
        this.filterData = filterData;
      }
    });
  }

  private initCurrentTitle(): void {
    this.routeTitleService.currentTitle$.subscribe({
      next: (title: string) => {
        this.currentTitle = title;
      }
    });
  }

  private initIsMobile(): void {
    this.screenSizeService.isMobile$.subscribe({
      next: (isMobile: boolean) => {
        this.isMobile = isMobile;
      }
    });
  }
}
